import React from "react";
import {NotFoundContainer, NotFoundHeading} from "../style/not_found_styles";

const NotFound = () => (
    <NotFoundContainer>
        <NotFoundHeading>404 - Page Not Found!</NotFoundHeading>
    </NotFoundContainer>
);

export default NotFound;